import { action } from "../../../utils/actions";

export const ROUTE_CHANGED = "ROUTE_CHANGED";
export const INIT_APPLICATION = action("INIT_APPLICATION");
export const GET_APP_DATA = action("GET_APP_DATA");
export const GET_STRINGS = action("GET_STRINGS");
export const GO_TO_LOGIN = action("GO_TO_LOGIN");
export const GET_USER = action("GET_USER");
export const UPDATE_SITEMAP = action("UPDATE_SITEMAP");
export const UPDATE_SITEMAP_PATH = action("UPDATE_SITEMAP_PATH");
export const OPEN_MODULE = action("OPEN_MODULE");
export const SHOW_MESSAGE = action("SHOW_MESSAGE");
export const CLOSE_MESSAGE = action("CLOSE_MESSAGE");
export const ENTITY_UPDATED = "ENTITY_UPDATED";
export const SWITCH_STRINGS = "SWITCH_STRINGS";
export const STRINGS_UPDATED = "STRINGS_UPDATED";
export const SMS_STRINGS_UPDATED = "SMS_STRINGS_UPDATED";
export const EMAIL_STRINGS_UPDATED = "EMAIL_STRINGS_UPDATED";
export const STRINGS_DELETED = "STRINGS_DELETED";
export const SMS_STRINGS_DELETED = "SMS_STRINGS_DELETED";
export const EMAIL_STRINGS_DELETED = "EMAIL_STRINGS_DELETED";
export const SET_APP_READY = "SET_APP_READY";
export const PAGE_FOCUSED = "PAGE_FOCUSED";
export const TOGGLE_SIDE_MENU = "TOGGLE_SIDE_MENU";
export const EXPAND_SIDE_MENU = "EXPAND_SIDE_MENU";
export const SEND_FEEDBACK = action("SEND_FEEDBACK");
